module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_stromstad-2acd26d3c33ad760b94d3569e0dca2ff.png";